import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { LANDING_COMPARISON_ROWS, LANDING_SECTION_COMPARISON } from '../../landing/landingCopy';

const LscLandingComparison: React.FC = () => {
  return (
    <section className="space-y-8" data-testid="lsc-landing-comparison">
      <div className="text-center space-y-3">
        <h2 className="text-2xl md:text-3xl font-bold text-white">{LANDING_SECTION_COMPARISON}</h2>
        <p className="text-secondary-400 max-w-2xl mx-auto">
          LSC is the missing league-media layer — not a replacement for where you stream or talk.
        </p>
      </div>
      <div className="grid gap-5 lg:grid-cols-3 lg:items-stretch">
        {LANDING_COMPARISON_ROWS.map(({ platform, limitation, lscAdds, featured }) => (
          <article
            key={platform}
            className={`rounded-xl p-5 space-y-3 transition duration-200 ${
              featured
                ? 'border border-primary-600/50 bg-gradient-to-b from-primary-950/40 via-secondary-900/90 to-secondary-950 shadow-xl shadow-primary-950/30 ring-1 ring-primary-500/20 lg:-translate-y-1'
                : 'border border-secondary-700/80 bg-secondary-800/40 hover:border-secondary-600'
            }`}
            data-testid="lsc-landing-comparison-card"
            data-comparison-featured={featured ? 'true' : 'false'}
          >
            <div className="flex items-center gap-2">
              {featured ? (
                <CheckCircle2 className="h-5 w-5 text-primary-400 shrink-0" aria-hidden />
              ) : null}
              <h3 className={`text-lg font-semibold ${featured ? 'text-white' : 'text-secondary-100'}`}>
                {platform}
              </h3>
            </div>
            {limitation ? <p className="text-sm text-secondary-400">{limitation}</p> : null}
            <p className={`text-sm ${featured ? 'text-secondary-100 font-medium' : 'text-secondary-300'}`}>
              {lscAdds}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default LscLandingComparison;
